import script from "./FlyingTiger-Locations.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyingTiger-Locations.vue?vue&type=script&setup=true&lang=js"

import "./FlyingTiger-Locations.vue?vue&type=style&index=0&id=0be1deab&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be1deab"]])

export default __exports__